import PropTypes from "prop-types"
import React, { useEffect, useState, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"
import { useSelector } from "react-redux";
import moment from 'moment';
// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"
import { getCollectZoneList, getCarList, getDriverList } from "../../crud/search.crud"
import { getCompanyList, getMyTreatmentCompanyList } from "../../crud/contract.crud"
import { getTopData } from "../../crud/dashboard.crud"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { getDisposeList } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import Modal from "components/RopikCustom/Modal_v2";
import SelectBox from "components/RopikCustom/SelectBox";
import { saveDispose } from "crud/collect.crud";
import Loading from "pages/Custom/Loading";
import * as XLSX from 'xlsx';

const initDashboardItem = [
  { text: '금일 총 수거량', unit: 'ℓ', value: 0 },
  { text: '금일 총 인계량', unit: 'ton', value: 0 },
  { text: '전일 총 수거량', unit: 'ℓ', value: 0 },
  { text: '전일 총 인계량', unit: 'ton', value: 0 },
]

const initSearchCondition = {
  treatmentCompanyName: '',
  car: '',
  disposeDate: '',
  startDate: '',
  endDate: '',
  month: '',
  driver: '',
}


const initInputCondition = {
  id: '',
  companyName: '',
  treatmentCompanyName: '',
  contract_id: '',
  car: '',
  disposeDate: moment().hour() < 14 ? moment().clone().subtract(1, 'day').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
  driver: '',
  qty: 0,
  qty_l: 0,
  qty_kg: 0,
  price: 0,
  memo: '',
  state: 'I'
}

const stateData = [
  { id: 'I', name: '미완료' },
  { id: 'Y', name: '완료' },
]

const monthData = [
  { id: '01', name: '1월' },
  { id: '02', name: '2월' },
  { id: '03', name: '3월' },
  { id: '04', name: '4월' },
  { id: '05', name: '5월' },
  { id: '06', name: '6월' },
  { id: '07', name: '7월' },
  { id: '08', name: '8월' },
  { id: '09', name: '9월' },
  { id: '10', name: '10월' },
  { id: '11', name: '11월' },
  { id: '12', name: '12월' }
]

const DisposeHistory = () => {

  const selector = useSelector(state => state)
  const history = useHistory()

  const [dataList, setDataList] = useState([]);
  const [searchCondition, setSearchCondition] = useState(initSearchCondition)
  const [modalShow, setModalShow] = useState({
    edit: false,
  })
  const [dashboardItem, setDashboardItem] = useState(initDashboardItem)
  const [selectedItem, setSelectedItem] = useState(initInputCondition)
  const newDate = new Date()
  const nextDate = new Date()

  const [user, setUser] = useState(selector.auth?.user);
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [novelDate, setnovelDate] = useState(new Date());
  const [collectZoneData, setCollectZoneData] = useState([]);
  const [carData, setCarData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [treatmentCompanyData, setTreatmentCompanyData] = useState([]);
  const [driverData, setDriverData] = useState([]);
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getMyTreatmentCompanyData = async () => {
    try {
      setIsLoading(true)
      const response = await getMyTreatmentCompanyList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setTreatmentCompanyData([...content])
        } else {
          setTreatmentCompanyData([])
        }
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }

  const getSummaryData = async () => {
    try {
      const response = await getTopData();
      if (response.status === 200) {
        const content = response.data?.data || [];
        const item = [
          { text: '금일 총 수거량', unit: 'ℓ', value: Util.setCommaPrice(content?.todate_collect_qty_sum) },
          { text: '금일 총 인계량', unit: 'ton', value: Util.setCommaPrice(content?.todate_wearing_qty_sum / 1000) },
          { text: '전일 총 수거량', unit: 'ℓ', value: Util.setCommaPrice(content?.yesterday_collect_qty_sum) },
          { text: '전일 총 인계량', unit: 'ton', value: Util.setCommaPrice(content?.yesterday_wearing_qty_sum / 1000) },
        ]
        setDashboardItem(item)
      }
    } catch (error) {
      console.error(error);
    }
  }

  // const getCollectZoneDataList = async () => {
  //   try {
  //     const response = await getCollectZoneList();
  //     if (response.status === 200) {
  //       const content = response.data?.data || [];
  //       if (content.length > 0) {
  //         setCollectZoneData([...content])
  //       } else {
  //         setCollectZoneData([])
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  const getDriverDataList = async () => {
    try {
      const response = await getDriverList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setDriverData([...content])
        } else {
          setDriverData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCarDataList = async () => {
    try {
      const response = await getCarList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCarData([...content])
        } else {
          setCarData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getDataList = async () => {

    if (isLoading || isListEnd) {
      return;
    }
    setIsLoading(true)
    
    try {

      let newDate = moment(new Date()).format('YYYY-MM-DD')
      let tomorrow = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');

      const params = {
        driver_company: user.member_group?.[0]?.company_group?.id,
        company_name: searchCondition?.companyName || '',
        car: searchCondition?.car || '',
        driver: searchCondition?.driver || '',
        start_date: searchCondition?.startDate || newDate,
        end_date: searchCondition?.endDate || tomorrow,
        page: page,
      }

      const response = await getDisposeList(params);
      if (response.status === 200) {
        const content = response.data?.results || [];
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= response.data.count) {
          setIsListEnd(true)
        }
      }
      setIsLoading(false)
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
      setRefresh(false)
    }
  };


  const changeSearchCondition = (key, value) => {
    if (key == 'month' && value) {
      let now = moment();
      let currentMonth = now.month() + 2; // moment는 0~11 이라 +1

      let selectedMonth = parseInt(value, 10);
      let year;
      if (selectedMonth >= currentMonth) {
        year = now.year() - 1; // 이번 달부터는 작년
      } else {
        year = now.year();     // 그전까지는 올해
      }
      let startDate = `${year}-${value}-01`;
      let endDate = moment(startDate).add(1, 'month').format('YYYY-MM-DD');
      setSearchCondition(prev => ({ ...prev, [key]: value, startDate, endDate }))
    } else {
      setSearchCondition(prev => ({ ...prev, [key]: value }))
    }
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({ ...prev, [key]: true }))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({ ...prev, [key]: false }))
  }

  const changeInputCondition = (key, value) => {
    setSelectedItem(prev => ({ ...prev, [key]: value }))
  }


  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'인계내역 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }

  const saveDisposeItem = async () => {
    try {
      setIsLoading(true)

      const contract = treatmentCompanyData.filter(itm => itm.company === selectedItem?.treatmentCompanyName)?.[0]

      let price = selectedItem?.qty * (contract?.contract_group_data?.price_per_kg || 100)
      let vat = price * 0.1 || 0
      let total_price = price + vat || 0

      const params = {
        id: selectedItem?.id || '',
        treatment_company_id: selectedItem?.treatmentCompanyName,
        contract_id: selectedItem?.contract_id || '',
        car_id: selectedItem?.car,
        qty: selectedItem?.qty,
        qty_l: selectedItem?.qty_l,
        qty_kg: selectedItem?.qty_kg,
        member_id: selectedItem?.driver,
        price: price,
        vat: vat,
        total_price: total_price,
        dispose_date: selectedItem?.disposeDate,
        memo: selectedItem?.memo,
        state: selectedItem?.state
      }
      const response = await saveDispose(params);
      modalClose('edit')
      onSearch()
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getSummaryData()
    //getCollectZoneDataList()
    getCarDataList()
    getMyTreatmentCompanyData()
    getDriverDataList()
    getDataList()
  }, [])

  const onSearch = async () => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }

  useEffect(() => {
    if (refresh)
      getDataList()
  }, [refresh])

  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>인계내역 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="수거 관리" breadcrumbItem="인계내역 관리" />

          <Row>
            <Col xs='12'>
              <div className="email-rightbar mb-3">
                <Card>
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">처리장명</td>
                          <td className="col-20">
                            <input className="waver-input-box font-size-12 w-100 border-radius-0" placeholder="처리장명을 입력하세요." value={searchCondition.companyName} onChange={(e) => {
                              changeSearchCondition('treatmentCompanyName', e.target.value)
                            }} />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.car}
                              onChange={changeSearchCondition}
                              options={carData}
                              keyValue={'car'}
                            />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">기사선택</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.driver}
                              onChange={changeSearchCondition}
                              options={driverData}
                              keyValue={'driver'}
                            />
                          </td>
                          <td className="col-10 padding-left-8 no-border" rowSpan={3}>
                            <div className="d-flex flex-direction-column align-items-end">
                              <button type="button" className="custom-btn btn-dark-gradient w-80 margin-bottom-8 border-radius-0 white-text border-none margin-right-0" onClick={() => {
                                onSearch()
                              }}>
                                검색
                              </button>
                              <button type="button" className="custom-btn w-80 border-radius-0 primary-bg white-text button-border margin-right-0" onClick={() => {
                                modalOpen('edit')
                              }}>
                                인계량 등록
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">검색기간</td>
                          <td colSpan={3} className="col-20">
                            <input style={{ width: 'calc((100% - 4px) / 2)' }} className="waver-input-box border-radius-0 margin-right-4" type="date" value={searchCondition.startDate} onChange={(e) => {
                              changeSearchCondition('startDate', e.target.value);
                            }} />
                            <input style={{ width: 'calc((100% - 4px) / 2)' }} className="waver-input-box border-radius-0" type="date" value={searchCondition.endDate} onChange={(e) => {
                              changeSearchCondition('endDate', e.target.value);
                            }} />
                          </td>
                          <td className="col-10 padding-left-8 primary-bg white-text font-size-12">월간 검색</td>
                          <td className="col-20">
                            <SelectBox
                              value={searchCondition.month}
                              onChange={changeSearchCondition}
                              options={monthData}
                              keyValue={'month'}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <Row>
            {dashboardItem.map((item, index) => (
              <Col xs={3} key={'collection_history_dashboard_' + index}>
                <div className="collect-history-box d-flex justify-content-between">
                  <div className="d-flex flex-column justify-content-between">
                    <p className="font-size-15 mb-0">{item.text}</p>
                  </div>
                  <div className="d-flex flex-column justify-content-end">
                    <p className="mb-0 font-size-50 font-weight-800 line-height-1">
                      {Util.setCommaPrice(item.value)}
                      <span className="font-size-18 font-weight-600"> {item.unit}</span>
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <div className="d-flex justify-content-between align-items-center mb-2 margin-top-40">
            <p className="mb-0 font-size-16"><span className="font-weight-bold">인계내역 목록</span> [ 건수 : {totalElements}건 / 수거시간 최신 순 ]</p>
            <div className="waver-pagination-btn-group" >
              <button style={{ width: 143 }} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
                onClick={() => {
                  excelDownload()
                }} >
                엑셀 다운로드
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                    <div id={"sc-body"} style={{ maxHeight: 660 }} className="table-responsive">
                      <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">인계일자</th>
                            <th scope="col">인계차량</th>
                            <th scope="col">운반기사</th>
                            <th scope="col">처리장명</th>
                            <th scope="col">인계현황</th>
                            <th scope="col">인계량(ℓ)</th>
                            <th scope="col">인계량(kg)</th>
                            <th scope="col">수정</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.length > 0 && dataList.map((item, index) => {
                            return (
                              <tr key={item.id + '_' + index}>
                                <td className="pointer" >{dataList.length - index}</td>
                                <td className="pointer" >{moment(item.created_at).format('YYYY-MM-DD')}</td>
                                <td className="pointer" >{item.car?.number || ''}</td>
                                <td className="pointer" >{item.member?.username}</td>
                                <td className="pointer" >{item.wearing_company?.name}</td>
                                <td
                                  className="pointer"
                                  style={{ color: item.state === 'Y' ? 'blue' : 'red' }}
                                >
                                  {item.state === 'Y' ? '완료' : '미완료'}
                                </td>
                                <td className="pointer" >{Util.setCommaPrice(item.qty)}</td>
                                <td className="pointer" >{Util.setCommaPrice(item.qty)}</td>
                                <td>
                                  <div className="btn-group waver-common-btn-group w-90">
                                    <Button type="button" size="sm" disabled={item.is_editable == 'N'} className="w-100 waves-effect center-btn btn-common small disactive" onClick={(e) => {
                                      e.stopPropagation()
                                      setSelectedItem({
                                        id: item?.id,
                                        companyName: item.company?.id,
                                        treatmentCompanyName: item?.wearing_company?.id,
                                        car: item.car?.id,
                                        disposeDate: item.dispose_date,
                                        driver: item.member?.id,
                                        contract_id: item.contract_id,
                                        qty: item.qty,
                                        qty_l: item.qty_l,
                                        qty_kg: item.qty_kg,
                                        memo: item.memo,
                                        state: item.state
                                      })
                                      modalOpen('edit')
                                    }}>수정</Button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {isLoading && <Loading />}
                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        title={selectedItem?.id ? '인계 내용 수정' : '인계 내용 등록'}
        show={modalShow.edit}
        onHide={() => {
          modalClose('edit')
          setSelectedItem(initInputCondition)
        }}
        size="lg"
        bodyChildren={
          <Fragment>
            <table className="input-table">
              <tbody>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">차량선택</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.car || ''}
                      onChange={changeInputCondition}
                      options={carData}
                      keyValue={'car'}
                      disabled={selectedItem?.id}
                    />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">기사선택</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.driver || ''}
                      onChange={changeInputCondition}
                      options={driverData}
                      keyValue={'driver'}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계일자</td>
                  <td className="w-35">
                    <input className="waver-input-box w-100 border-radius-0" disabled={selectedItem?.id} type="date" value={selectedItem?.disposeDate} onChange={(e) => {
                      changeInputCondition('disposeDate', e.target.value);
                    }} />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계량</td>
                  <td className="w-35">
                    <input className='waver-input-box w-100 border-radius-0' value={selectedItem?.qty} placeholder="인계량을 입력해 주세요." onChange={(e) => {
                      changeInputCondition('qty', e.target.value)
                    }} />
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거량(ℓ)</td>
                  <td className="w-35 text-end">{selectedItem?.qty_l}</td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">수거량(kg)</td>
                  <td className="w-35 text-end">{selectedItem?.qty_kg}</td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">처리장명</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.treatmentCompanyName || ''}
                      onChange={changeInputCondition}
                      options={treatmentCompanyData}
                      keyValue={'treatmentCompanyName'}
                    />
                  </td>
                  <td className="w-15 padding-left-8 primary-bg white-text font-size-12">인계상태</td>
                  <td className="w-35">
                    <SelectBox
                      value={selectedItem?.state || ''}
                      onChange={changeInputCondition}
                      options={stateData}
                      keyValue={'state'}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="w-15 padding-left-8 primary-bg white-text">메모</td>
                  <td colSpan="3" className="w-85 pb-0">
                    <textarea className="waver-text-box w-100 font-size-12 border-radius-0" value={selectedItem?.memo}
                      onChange={(e) => {
                        changeInputCondition('memo', e.target.value);
                      }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        }
        footerChildren={
          <div className="d-flex justify-content-end w-100">
            <div className="d-flex">
              <button style={{ width: 112, height: 27 }} className="`custom-btn border-radius-0 margin-right-4 font-size-11 line-height-1 secondary-bg white-text border-none" onClick={() => {
                saveDisposeItem()
              }}>{selectedItem?.id ? '인계 내용 수정' : '인계 내용 등록'}</button>
              <button style={{ width: 59, height: 27 }} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
                setSelectedItem(null)
                modalClose('edit')
              }}>취소</button>
            </div>
          </div>
        }
      />
    </React.Fragment>
  )
}

export default DisposeHistory
